module.exports = __webpack_public_path__ + "static/book-app-cover-038863d9bd648c81fbae80e29609da67.png";